export const FIND_ASSIGNABLE_ROUTINE_ASSETS = `
  query FindAssignableRoutineAssets($filter: FindAssignableRoutineAssetsFilter!, $page: PageRequest) {
    routine {
      findAssignableRoutineAssets(filter: $filter, page: $page) {
        count
        limit
        offset
        items {
          id
          name
          description
          groups {
            id
            name
          }
        }
      }
    }
  }
`;
